import(/* webpackMode: "eager" */ "/app/lib/StyledComponentsRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ContainerTemplate","ItemTemplate"] */ "/app/src/components/Container/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ContentStyled"] */ "/app/src/components/Content/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MainHeader/utils/logout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SimpleHeader/SimpleHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SimpleHeader/SimpleHeaderOld.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EcommerceProviders"] */ "/app/src/context/ecommerceProviders.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/layouts/styles/GlobalStyles.tsx");
